import { useState, useEffect, useCallback } from 'react';

const IconSeed = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22V12" />
    <path d="M12 12C12 12 8 10 8 6a4 4 0 0 1 8 0c0 4-4 6-4 6z" />
    <path d="M12 15c0 0-3 1-4 4" />
  </svg>
);
const IconFlame = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
  </svg>
);
const IconHeart = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
  </svg>
);
const IconStar = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

function getMensagem(streak, mood) {
  // Humor difícil tem prioridade
  if (mood === 1) return {
    icone: <IconHeart />,
    cor: 'var(--blush)',
    titulo: 'Obrigada por aparecer.',
    sub: 'Mesmo sendo difícil, você escolheu estar aqui.',
  };
  if (mood === 5) return {
    icone: <IconStar />,
    cor: 'var(--lavender)',
    titulo: 'Que alegria sentir você assim!',
    sub: 'Continue celebrando!',
  };
  if (streak >= 30) return {
    icone: <IconFlame />,
    cor: 'var(--blush)',
    titulo: 'Um mês inteiro!',
    sub: 'Algo muito especial está sendo construído!',
  };
  if (streak >= 21) return {
    icone: <IconFlame />,
    cor: 'var(--blush)',
    titulo: '21 dias.',
    sub: 'O hábito já é seu!',
  };
  if (streak >= 7) return {
    icone: <IconFlame />,
    cor: 'var(--lavender)',
    titulo: 'Uma semana inteira.',
    sub: 'Que conquista!',
  };
  if (streak >= 3) return {
    icone: <IconFlame />,
    cor: 'var(--teal)',
    titulo: `${streak} dias seguidos.`,
    sub: 'Você está criando um hábito!',
  };
  if (streak === 1) return {
    icone: <IconSeed />,
    cor: 'var(--teal)',
    titulo: 'Você está aqui.',
    sub: 'Isso já é muito!',
  };
  return {
    icone: <IconSeed />,
    cor: 'var(--lavender)',
    titulo: 'Mais um dia de presença.',
    sub: 'Você está construindo algo especial!',
  };
}

export default function MicroCelebracao({ streak, mood, onFim }) {
  const [saindo, setSaindo] = useState(false);
  const mensagem = getMensagem(streak, mood);

  const iniciarSaida = useCallback(() => setSaindo(true), []);

  useEffect(() => {
    const t = setTimeout(iniciarSaida, 1800);
    return () => clearTimeout(t);
  }, [iniciarSaida]);

  useEffect(() => {
    if (!saindo) return;
    const t = setTimeout(onFim, 400);
    return () => clearTimeout(t);
  }, [saindo, onFim]);

  return (
    <div
      className={`micro-celebracao-backdrop ${saindo ? 'saindo' : ''}`}
      onClick={iniciarSaida}
    >
      <div className={`micro-celebracao-card ${saindo ? 'saindo' : ''}`}>
        <div className="micro-celebracao-icone" style={{ color: mensagem.cor }}>
          {mensagem.icone}
        </div>
        <p className="micro-celebracao-titulo">{mensagem.titulo}</p>
        <p className="micro-celebracao-sub">{mensagem.sub}</p>
      </div>
    </div>
  );
}
